<template>
    <div id="nav">
      <div v-if="isPC" id="copyright">©SMchat</div>
        <div id="items" v-if="isPC">
          <div class="content">
            <router-link to="/faq">常見問題</router-link><span>|</span>
            <router-link to="/service">服務條款</router-link><span>|</span>
            <router-link to="/privacy">隱私權政策</router-link><span>|</span>
            <router-link to="/contact">聯絡我們</router-link>
            <div id="company">
              品睿數位媒體行銷有限公司 29188637
            </div>
          </div>
        </div>
        <div v-else>
          <div id="items">
            <router-link to="/faq">常見問題</router-link>
            <router-link to="/service">服務條款</router-link>
            <router-link to="/privacy">隱私權政策</router-link>
            <router-link to="/contact">聯絡我們</router-link>
          </div>
          <div id="copyright">©SMchat</div>
          <div id="company" class="mt-10">
            品睿數位媒體行銷有限公司 29188637
          </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'navBar',
  data () {
    return {
      isPC: true
    }
  },
  mounted () {
    const width = this
    width.fullWidth = window.innerWidth
    if (width.fullWidth >= 768) {
      this.isPC = true
    } else {
      this.isPC = false
    }
    window.onresize = () => {
      width.fullWidth = window.innerWidth
      if (width.fullWidth >= 768) {
        this.isPC = true
      } else {
        this.isPC = false
      }
    }
  }
}
</script>

<style>
@media screen and (max-width: 767px) {
  #nav{
    position: fixed;
    bottom:0;
    background: #2b2b2b;
    width: 100vw;
    padding: 27px 0 14px 0;
    display: flex;
    flex-direction: column-reverse;
    align-items: center;
    text-align: center;
  }
  #items{
    display: flex;
    flex-direction: column;
  }
  #items a{
    margin-bottom:14px;
  }
}
@media screen and (min-width: 768px) {
  #nav{
    position: fixed;
    bottom:0;
    background: #2b2b2b;
    width: 100vw;
    padding: 26px 0;
    display: flex;
    align-items: baseline;
  }
  #copyright{
    flex-basis: 34vw;
    display: flex;
    justify-content: flex-end;
    margin-right: 5vw;
    font-size: 19px;
  }
  #items{
    /* flex-basis: 61vw; */
    font-size: 18px;
    line-height: 1.33;
  }
}
#items span{margin: 0 20px;}
#items a,#items, #copyright{
  color:white;
  text-decoration:none;
}
.content {
  display: flex;
  align-items: center;
}
#company {
  color:white;
  display: flex;
  justify-content: center;
  font-size: 14px;
  margin-left: 5vw;
}
.mt-10 {
  margin-top: 10px;
}
</style>
